import request from '@/utils/request'

export default {
  getCompanyCulture () {
    return request.get('/django_rest/company-culture/')
  },
  updateCompanyCulture (params) {
    return request.put('/django_rest/company-culture/', params)
  }
}
